export default class SessionCharge {
  constructor(API) {
    this.api = API;
  }
  async getSessionChargeByUserIDAndTimestamp(sessionID, userID, timestamp) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/session/' + sessionID + '/charge/' + userID + '/' + timestamp;
    return await req.exec();
  }
  async getSessionChargesByUserID(sessionID, userID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/session/' + sessionID + '/charges/' + userID;
    return await req.exec();
  }
}
